// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs-messaging-module_tabs__2hK_b","panel":"tabs-messaging-module_panel__VtjgO"};